module.exports = __webpack_public_path__ + "static/img/code.94d2f2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/code.png
// module id = 3rRJ
// module chunks = 10